import useSWR from "swr";
import { fetcher } from "./lib/fetcher";

/**
 * Hook to get installed capacity data from API using SWR.
 * @param {string} location_key - a unique identifier for the location, e.g. Sachsen_Ort_Leipzig.
 * @returns {{ rawData: object | null, error: Error | null, loading: boolean }}
 */
export const useFetchEnergyData = (location_key) => {
  const shouldFetch = Boolean(location_key);
  const apiUrl = process.env.REACT_APP_API_BASE_URI;
  
  const { data, error, isValidating } = useSWR(
    shouldFetch 
    ? `${apiUrl}/installed_capacity?location_key=${location_key}` 
    : null,
    fetcher
  );

  return {
    rawData: data,
    error,
    loading: isValidating && !data,
  };
};
